import {ErrorsObjectInterface} from "./errors-object.interface";

export interface OvdalError {
    statusCode: number;
    message: string;
    validationErrors?: ErrorsObjectInterface;
}
